import cn from 'classnames';
import { Avatar } from '@Components/Avatar';
import { Img } from '@Components/Img';
import { CDN } from '@Components/MetricsTable/metrics-table-utils';

const NO_LOGO_AVATAR_SIZE = 28;

interface CompanyLabelProps {
  company: string;
  // The By Campaign tab passes this (possibly null) and gets a fixed-width label with a sublabel.
  campaign?: string | null;
}

export const CompanyLabel = ({ company, campaign }: CompanyLabelProps) => (
  <div
    className={cn('pacing-label', { 'pacing-label-campaign': campaign !== undefined })}
    data-testid={`company-label-${company}`}
  >
    <div className='logo company'>
      <Img
        src={`${CDN}/companies/${company}/logo.png`}
        title={company}
        unloader={
          <div className='no-logo'>
            <Avatar name={company} size={NO_LOGO_AVATAR_SIZE} />
            <span className='no-logo-name'>{company}</span>
          </div>
        }
      />
    </div>
    {campaign && <span className='sub-label'>{campaign}</span>}
  </div>
);

export const NetworkLabel = ({ network }: { network: string }) => (
  <div className='pacing-label pacing-label-network' data-testid={`network-label-${network}`}>
    <Img
      className='logo network'
      src={`${CDN}/networks/${network}.png`}
      title={network}
      unloader={<Avatar name={network} size={NO_LOGO_AVATAR_SIZE} />}
    />
  </div>
);
